import { toUserMessage } from './error';

/**
 * Message to show the user for a thrown value of unknown type.
 *
 * Apollo rejects with an ApolloError (an Error subclass), but a network layer or
 * a non-Error throw can surface anything, so this narrows instead of asserting
 * `any` at every catch site.
 */
export function errorMessageOf(error: unknown, fallback: string): string {
  if ((error instanceof Error && error.message) || (typeof error === 'string' && error)) {
    return toUserMessage(error, fallback);
  }

  return fallback;
}
